import "react-phone-number-input/style.css";

import React, { Fragment } from "react";
import PhoneInput from "react-phone-number-input";

const TelInput = ({
  input: { value, onChange },
  width,
  type,
  placeholder,
  meta: { touched, error },
  options
}) => {
  return (
    <Fragment>
      <PhoneInput
        country="MY"
        defaultCountry="MY"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error}
      ></PhoneInput>
      {touched && error && <label className="error-label">{error}</label>}
    </Fragment>
  );
};

export default TelInput;
